import { INSURANCE_MATCH_TILES } from "../data/insuranceMatch";
import { InsuranceMatchTile } from "./InsuranceMatchTile";

const CURVED_LINE = "/assets/pack-zero-franchise/curved-line.svg";

export const InsuranceMatchSection = () => {
  return (
    <section className="overflow-hidden bg-white px-2 md:px-6 py-[120px] ">
      <div className="relative mx-auto w-full max-w-[1600px]">
        <img
          src={CURVED_LINE}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none rotate-90 xl:rotate-0"
        />
        <div className="relative flex flex-col items-center justify-center gap-12 xl:flex-row">
          {INSURANCE_MATCH_TILES.map((tile) => (
            <InsuranceMatchTile key={tile.id} tile={tile} />
          ))}
        </div>
      </div>
    </section>
  );
};
